import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@reducate/ui";
import type { ReducateSelectFieldProps } from "../types/reducate.js";

export function SelectField({
  controlId,
  id,
  value,
  placeholder,
  options,
  onValueChange,
  describedBy,
}: ReducateSelectFieldProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        aria-describedby={describedBy}
        className="min-h-11 w-full"
        data-control-id={controlId}
        id={id}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent position="popper">
        {options.map((option) => (
          <SelectItem
            data-control-id={`${controlId}.option.${option.value}`}
            key={option.value}
            value={option.value}
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
